var map = {
	"./IMG-20250506-WA0002.jpg": 10469,
	"./IMG-20250506-WA0003.jpg": 83304,
	"./IMG-20250506-WA0005.jpg": 65470,
	"./IMG-20250506-WA0012.jpg": 28234,
	"./IMG-20250506-WA0014.jpg": 78076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80438;